import { observer } from 'mobx-react-lite';
import { lightable, lighted, LightningProps } from 'owa-lightning-v2';
import { NewConsumerRecruitmentForm } from 'owa-feedback';
import * as React from 'react';

export default lightable(
    observer(function NewConsumerRecruitmentFormCallout(props: LightningProps) {
        const onExit = () => {
            lighted(props.lid);
        };

        return <NewConsumerRecruitmentForm onExit={onExit} />;
    })
);
